import React, { useEffect, useState } from 'react';
import { XCircle, AlertTriangle, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

export const PIONEER_STATES = {
  none: { label: 'Sem oferta', cls: 'bg-gray-100 text-gray-600' },
  sent: { label: 'Oferta enviada', cls: 'bg-amber-100 text-amber-800' },
  accepted: { label: 'Aceite', cls: 'bg-emerald-100 text-emerald-800' },
  logo_pending: { label: 'Logótipo por aprovar', cls: 'bg-orange-100 text-orange-800' },
  on_wall: { label: 'No Muro', cls: 'bg-slate-900 text-amber-300' },
};

export const PioneerStateBadge = ({ company }) => {
  const st = PIONEER_STATES[company.pioneer_state] || PIONEER_STATES.none;
  return (
    <span className={`inline-flex items-center text-[10px] font-bold px-2 py-0.5 rounded-full ${st.cls}`} data-testid={`pioneer-state-${company.id}`}>
      Pioneiro: {st.label}
    </span>
  );
};

export const ProspectingOffersPanel = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(null);
  const load = () => api.get('/admin/trial-offers/prospecting').then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  if (!items.length) return null;

  const cancel = async (o) => {
    if (!window.confirm(`Cancelar a oferta Pioneiro automática de ${o.company_name || o.prospect_email}?`)) return;
    setBusy(o.id);
    try {
      await api.post(`/admin/trial-offers/${o.id}/cancel`);
      toast.success('Oferta cancelada.');
      setItems((prev) => prev.filter((x) => x.id !== o.id));
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao cancelar.');
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 p-4" data-testid="prospecting-offers-panel">
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} className="flex w-full items-center gap-2 text-left" data-testid="prospecting-offers-toggle">
        <ChevronRight className={`h-4 w-4 text-amber-700 transition-transform ${open ? 'rotate-90' : ''}`} />
        <AlertTriangle className="h-4 w-4 text-amber-700" />
        <h2 className="text-sm font-bold text-amber-900">Ofertas Pioneiro antigas criadas pela prospecção ({items.length})</h2>
      </button>
      {open && <>
      <p className="text-xs text-amber-800 mb-3 mt-1">Ainda não foram aceites. Nenhuma é cancelada automaticamente — decida uma a uma.</p>
      <ul className="divide-y divide-amber-200">
        {items.map((o) => (
          <li key={o.id} className="flex items-center gap-3 py-2 text-sm" data-testid={`prospecting-offer-${o.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-gray-900 truncate">{o.company_name || '—'}</div>
              <div className="text-xs text-gray-500 truncate">{o.prospect_email} · {o.sent_at ? new Date(o.sent_at).toLocaleDateString('pt-PT') : '—'}</div>
            </div>
            <button type="button" disabled={busy === o.id} onClick={() => cancel(o)} className="inline-flex items-center gap-1 h-8 px-3 text-xs font-semibold rounded-md border border-amber-300 bg-white text-amber-900 hover:bg-amber-100 disabled:opacity-60" data-testid={`cancel-offer-btn-${o.id}`}>
              <XCircle className="h-3.5 w-3.5" />Cancelar oferta
            </button>
          </li>
        ))}
      </ul>
      </>}
    </div>
  );
};
